// removed by extract-text-webpack-plugin
module.exports = {"PayPalPaymentField":"bFiI8cF1Dj7TRI1_S9oYr","PayPalPaymentField__loadingIndicator":"_1-EYfAwn4z1-CpBIFLXSXw","PayPalPaymentField__initBox":"_788cbPYWT3cpo9s_yOtbg","PayPalPaymentField__initInfo":"_2GY5frY3YfISnFdImKF4_5","PayPalPaymentField__initButton":"Fx6b7eV4Zwm4gJJmkMrYf","PayPalPaymentField__detailsLabel":"_2nb3M19_ifKnBf43H7j8CF","PayPalPaymentField__email":"_1y9Nzkbbyl5ICyW4SFEkjZ","PayPalPaymentField__cancelButton":"t-XkPdnBXszQR8A2041NS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PayPalPaymentField/PayPalPaymentField.scss
// module id = 2659
// module chunks = 0